// extracted by mini-css-extract-plugin
export default {"container":"dashboardheader_container__oCVH-","menu":"dashboardheader_menu__0Gzde"};